import Task from '../Task.vue'

export default [
    {
        path: '/task', 
        name: '/task', 
        meta: { layout: 'mystagit' },
        component: Task,
    }
]